module.exports = __webpack_public_path__ + "img/cwtw_camelottoken.86a90e1.png";